import { TextStyled } from '@nike/nike-design-system-components';
import React from 'react';

import './overrides.css';
import { SECURITY_ROLES_ENUM } from '../../../../constants/roles.const';
import { PATH_TILL_IN, PATH_TILL_OUT } from '../../../../constants/routes.const';
import { useGetLocalization } from '../../../../hooks';
import { ID_TILL_IN_BUTTON, ID_TILL_OUT_BUTTON } from '../../../../utils/dom-element-ids';
import { PermissionsContainer, Placeholder, Subheader } from '../../../reusable';

const DANGER_BUTTON_CLASS = 'overrides-danger-button';

function Overrides() {
  const getLocalization = useGetLocalization();

  const warningPrefix = getLocalization('lbl.emergency-only');
  const tillInLabel = `${warningPrefix}: ${getLocalization('lbl.till-in')}`;
  const tillOutLabel = `${warningPrefix}: ${getLocalization('lbl.till-out')}`;

  return (
    <>
      <Subheader>{getLocalization('lbl.overrides')}</Subheader>
      <PermissionsContainer
        fallback={getLocalization('msg.no-permission')}
        requiredLevel={SECURITY_ROLES_ENUM.LEVEL_20}
      >
        <TextStyled appearance="body1" Component="p" className="mb5-sm text-color-error">
          {getLocalization('msg.overrides-register-warning')}
        </TextStyled>
        <Placeholder
          className={DANGER_BUTTON_CLASS}
          id={ID_TILL_IN_BUTTON}
          name={tillInLabel}
          redirect={PATH_TILL_IN}
        />
        <Placeholder
          className={DANGER_BUTTON_CLASS}
          id={ID_TILL_OUT_BUTTON}
          name={tillOutLabel}
          redirect={PATH_TILL_OUT}
        />
      </PermissionsContainer>
    </>
  );
}

export default Overrides;
